import(/* webpackMode: "eager" */ "/app/src/app/compare/excel/page.tsx");
